module.exports = __webpack_public_path__ + "img/stripe-logo.be10f604.svg";